import React from 'react';
import { Pill } from 'lucide-react';

const MedicationsEmptyState: React.FC = () => {
  return (
    <div className='text-center py-8 text-muted-foreground'>
      <Pill className='h-12 w-12 mx-auto mb-4 opacity-50' />
      <p>No medications added yet</p>
      <p className='text-sm mt-1'>Click "Add Medication" to add a medication</p>
    </div>
  );
};

export default MedicationsEmptyState;
